<template>
	<section class="m-index" v-if="podcastItems.length > 0">
		<div class="box">
			<div class="top-cards">
				<div
					class="video-item"
					v-for="(item, index) in bigCards"
					:key="item.id || index"
					:ref="el => bindPodcastCardRef(el, item, index)"
					@click="handleToSquareDetail(item, index)"
				>
					<img class="video-item-banner" :src="item.cover" alt="" />
					<img
						class="video-item-play"
						src="../../../images/vedio2.png"
						alt=""
						@click.stop="handleVideoPlayClick(item, index)"
					/>
					<div class="video-item-title">
						<img :src="item.avatar" alt="" />
						<span>{{ item.title }}</span>
					</div>
					<div class="video-item-author">
						<span class="video-item-author-name">{{ item.nickname }}</span>
						<img src="../../../images/eye.png" alt="" />
						<span class="video-item-author-view">{{ formatViewCount(item.view_count) }}</span>
					</div>
					<div class="video-item-duration">
						{{ item.media_second_str || safeFormatTime(item.media_second) }}
					</div>
				</div>
			</div>

			<div class="box2" v-if="smallCards.length > 0">
				<ul>
					<li
						v-for="(item, index) in smallCards"
						:key="item.id || index"
						:ref="el => bindPodcastCardRef(el, item, index + bigCards.length)"
						@click="handleToSquareDetail(item, index + bigCards.length)"
					>
						<div class="content">
							<div class="pic">
								<img :src="item.cover" alt="" />
								<img
									src="../../../images/vedio.png"
									alt=""
									class="vedio"
									v-if="item.type == 1"
									@click.stop="handleVideoPlayClick(item, index + bigCards.length)"
								/>
								<div class="mask" v-if="item.type == 1"></div>
								<div class="time" v-if="item.type == 1">
									{{ safeFormatTime(item.media_second) }}
								</div>
							</div>
							<div class="juzi">
								<p class="juzi1">{{ item.title }}</p>
								<p class="juzi2">
									<img src="../../../images/eye.png" alt="" />{{ formatViewCount(item.view_count) }}
								</p>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="recommend-title">
			<!-- <span>{{ t("square.recommend.title") }}</span> -->
			<div type="button" class="more-btn" @click="handleMore">
				<span>{{ t("square.recommend.viewMorePodcast") }}</span>
			</div>
		</div>
	</section>
</template>

<script setup>
import { computed, inject } from "vue";
import { useI18n } from "~/composables/useI18n";
import { buildOssImageUrl } from "~/utils/oss-image";
import { useSquareMobilePageData } from "@variants/seer/square/composables/useSquarePageData";
import {
	buildContentParams,
	MEDIA_TYPES,
	useMediaCardImpression,
} from "../../../composables/useMediaSquareTracking";

const formatTime = inject("formatTime");
const toSquareDetail = inject("toSquareDetail");
const mediaTracking = inject("mediaSquareTracking", null);
const { t, locale } = useI18n();

const safeFormatTime = seconds => {
	if (typeof formatTime === "function") {
		return formatTime(seconds);
	}
	const total = Number(seconds) || 0;
	const m = Math.floor(total / 60);
	const s = total % 60;
	return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
};

const { bindCardRef: bindPodcastCardRef } = useMediaCardImpression({
	track: (eventName, params) => mediaTracking?.track(eventName, params),
	impressionEvent: "podcast_card_impression",
	getItemParams: (item, index) =>
		buildContentParams(item, {
			position: index,
			formatTime: safeFormatTime,
			authorFallback: t("square.podcast.defaultAuthor"),
		}),
});

const formatViewCount = count => {
	const value = Number(count) || 0;
	if (value >= 10000) {
		if (locale.value === "en") {
			return t("square.views.count", { count: `${(value / 1000).toFixed(1)}K` });
		}
		return t("square.views.tenThousand", { count: (value / 10000).toFixed(1) });
	}
	return t("square.views.count", { count: value });
};

const handleToSquareDetail = (item, index) => {
	mediaTracking?.trackPodcastCardClick(
		item,
		index,
		safeFormatTime,
		t("square.podcast.defaultAuthor")
	);
	if (typeof toSquareDetail === "function") {
		toSquareDetail(item);
	}
};

const handleVideoPlayClick = (item, index) => {
	mediaTracking?.trackVideoPlayClick(item, {
		mediaType: MEDIA_TYPES.PODCAST,
		position: index,
		formatTime: safeFormatTime,
		authorFallback: t("square.podcast.defaultAuthor"),
	});
	if (typeof toSquareDetail === "function") {
		toSquareDetail(item);
	}
};

const pageData = useSquareMobilePageData();

const podcastItems = computed(() => {
	const featured = pageData.value?.recommend?.featuredLeft;
	const list = pageData.value?.recommend?.podcastTopSix || [];
	const combined = featured ? [featured, ...list] : list;
	return combined.slice(0, 7).map(item => ({
		...item,
		cover: buildOssImageUrl(item?.cover || "", { strategy: "cover", w: 640, q: 80 }),
		avatar: buildOssImageUrl(item?.avatar || "", { strategy: "avatar", w: 96, h: 96, q: 80 }),
	}));
});

const bigCards = computed(() => podcastItems.value.slice(0, 3));
const smallCards = computed(() => podcastItems.value.slice(3, 7));

const handleMore = () => {
	mediaTracking?.trackMediaMoreClick({
		sectionId: "recommend",
		mediaType: MEDIA_TYPES.PODCAST,
		currentCount: podcastItems.value.length,
	});
	navigateTo({ path: "/seer/square/article", query: { tab: "1" } });
};
</script>

<style lang="scss" scoped>
@mixin huanhang {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	line-height: 1.5;
}

.m-index {
	margin-top: 20px;
	background-color: #ffffff;
	padding: 0 30px;

	.recommend-title {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 36px;
		color: #333333;
		font-weight: 500;
		margin: 30px 0 0;

		.more-btn {
			font-size: 28px;
			color: #999;
			border: none;
			padding: 5px 20px;
			border-radius: 8px;
			font-weight: 400;
		}
	}

	.box {
		overflow: hidden;
		background-color: #ffffff;

		.top-cards {
			display: flex;
			flex-direction: column;
			gap: 40px;
		}

		.video-item {
			width: 100%;
			border-radius: 16px;
			border: 1px solid #ececec;
			padding: 0 0 18px;
			box-sizing: border-box;
			position: relative;
			cursor: pointer;

			.video-item-banner {
				width: 100%;
				height: 350px;
				object-fit: cover;
				display: block;
				border-radius: 16px 16px 0 0;
			}

			.video-item-play {
				width: 48px;
				height: 48px;
				position: absolute;
				right: 32px;
				top: 32px;
			}

			.video-item-title {
				width: 100%;
				margin: 20px 0 0;
				display: flex;
				align-items: center;
				gap: 12px;
				padding: 0 20px;

				img {
					width: 64px;
					height: 64px;
					border-radius: 50%;
					flex-shrink: 0;
					object-fit: cover;
				}

				span {
					flex: 1;
					color: #333333;
					font-size: 32px;
					font-weight: 500;
					@include huanhang;
				}
			}

			.video-item-author {
				width: 100%;
				display: flex;
				align-items: center;
				gap: 10px;
				padding: 0 20px;

				.video-item-author-name {
					color: #595959;
					font-size: 24px;
					margin-left: 74px;
				}

				img {
					width: 36px;
					height: 36px;
					object-fit: cover;
				}

				.video-item-author-view {
					color: #a0a0a0;
					font-size: 24px;
				}
			}

			.video-item-duration {
				background: rgba(0, 0, 0, 0.58);
				border-radius: 8px;
				height: 36px;
				min-width: 78px;
				position: absolute;
				right: 24px;
				top: 300px;
				padding: 0 10px;
				box-sizing: border-box;
				color: #ffffff;
				font-size: 22px;
				display: flex;
				align-items: center;
				justify-content: center;
				white-space: nowrap;
				line-height: 1;
			}
		}

		.box2 {
			margin-top: 30px;
			background: #ffffff;
			border: 1px solid #efefef;
			border-radius: 16px;

			ul {
				display: flex;
				flex-direction: column;
				overflow: hidden;
				gap: 25px;
				padding: 20px;

				li {
					position: relative;
					width: 100%;
					background-color: #ffffff;
					cursor: pointer;

					.content {
						width: 100%;
						min-height: 150px;
						display: flex;
						align-items: center;

						.pic {
							position: relative;
							width: 230px;
							height: 150px;
							margin-right: 16px;
							overflow: hidden;
							flex-shrink: 0;
							border-radius: 10px;

							img {
								width: 100%;
								height: 100%;
								object-fit: cover;
							}

							.vedio {
								position: absolute;
								top: 5px;
								right: 10px;
								width: 16px;
								height: auto;
							}

							.mask {
								position: absolute;
								width: 100%;
								height: 100%;
								top: 0;
								background: linear-gradient(
									to bottom,
									rgba(0, 0, 0, 0) 0%,
									rgba(0, 0, 0, 0) 20%,
									rgba(0, 0, 0, 0) 65%,
									rgba(0, 0, 0, 0.3) 100%
								);
								pointer-events: none;
							}

							.time {
								position: absolute;
								bottom: 8px;
								right: 10px;
								font-size: 14px;
								color: #ffffff;
							}
						}

						.juzi {
							width: calc(100% - 246px);
							height: 150px;
							display: flex;
							flex-direction: column;
							justify-content: center;

							.juzi1 {
								font-size: 32px;
								font-weight: 500;
								color: #333333;
								margin-bottom: 8px;
								width: 100%;
								line-height: 1.4;
								display: -webkit-box;
								-webkit-line-clamp: 2;
								-webkit-box-orient: vertical;
								line-clamp: 3;
								overflow: hidden;
								text-overflow: ellipsis;
							}

							.juzi2 {
								display: flex;
								align-items: center;
								color: #a0a0a0;
								font-size: 24px;
								line-height: 1.5;
								gap: 6px;

								img {
									width: 24px;
									height: 24px;
								}
							}
						}
					}
				}
			}
		}

		.box2 ul li:last-child .content {
			border-bottom: none !important;
		}
	}
}
</style>
